module.exports = __webpack_public_path__ + "icofont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/icofont/fonts/icofont.woff
// module id = 2879
// module chunks = 67